import Search from 'Components/Search'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import React, { useState } from 'react'

export default React.memo(props => <Search limit={null} all defaultSort={[{ id: 'date_envoi', desc: 1 }]} raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
                                           path={'messagerie'} requete={Constants.donnee.message} module={Constants.module.MESSAGERIE}
                                           search={props.search || 'message_' + (props.name || '') + User.Entite.get().id}>
    <SearchForm/>
  </Search>
)

const SearchForm = React.memo(props => {

  const [search, setSearch] = useState(props.search || {})

  const searching = (data, name) => {
    const srh = {
      ...(search || {}),
      [name]: data
    }
    setSearch(srh)
    props.searching && props.searching(srh)
  }

  return (
    <div/>
  )
})


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/Message/Search/index.js